import { createContext } from 'react';

import type { ModalHost } from './modalHost';

export const ModalHostContext = createContext<ModalHost | null>(null);
